import * as React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { axisClasses } from '@mui/x-charts';

interface RegistrationData {
    month: string;
    registrations: number;
}

interface Props {
    data: RegistrationData[];
}

export default function BieuDoDangKy({ data }: Props) {
    return (
        <LineChart
            width={500}
            height={300}
            xAxis={[{ scaleType: 'point', data: data.map((d) => d.month) }]}
            series={[
                {
                    data: data.map((d) => d.registrations),
                    label: 'Số lượt đăng ký',
                    color: '#8884d8'
                }
            ]}
            sx={{
                [`& .${axisClasses.tickLabel}`]: {
                    fontSize: 12
                }
            }}
        />
    );
}
